// import { RemoteLogger } from '~/services/remote-logger'
import { log } from '@/services/log'
import { useAuthStore } from '@/stores/auth'

const NAME = 'Authorization Guard'

export default async function ({ path, meta: { requiresAuth } }) {
  const needsAuth = requiresAuth ?? true
  const authStore = useAuthStore()
  const isTech = authStore?.user?.isTechnician ?? false
  const isAuthPage = path === 'login' || path === 'logout' || false

  if (isTech || !needsAuth || isAuthPage) {
    if (isTech) log(NAME, ': User is technician ', isTech, 'Allowing navigation to', path, 'needsAuth', needsAuth)
    else if (isAuthPage) log(NAME, ': Allowing User request to login / logout route ', path, 'needsAuth', needsAuth)
    else if (!needsAuth) log(NAME, ': Allowing User request', path, 'since it is not protected resource')
    return true
  } else {
    let uri = path
    while (uri) {
      const canSee = authStore.canSee(uri)
      if (canSee) {
        log(NAME, ': Middleware requesting path and permission avialable', uri, canSee)
        return true
      }
      const lastSlashIndex = uri.lastIndexOf('/')
      if (lastSlashIndex === -1) {
        log(NAME, ': Middleware requesting route not found or unauthorized request', lastSlashIndex, uri)
        /*
        RemoteLogger.warn(context.$api, context.$dexie, {
          message: 'Middleware requesting route not found or unauthorized request',
          username: context.$auth?.user?.username,
          offendingMethod: 'Navigation',
          cause: `No permissions found for ${context.route.path}`,
          culpritClass: 'Permissions',
        })
        */
        return { path: '/unauthorization-view' }
      }
      uri = uri.substring(0, lastSlashIndex)
    }
  }
}
